import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const STATUS = { novo: "Novo", em_contato: "Em contato", concluido: "Concluído", arquivado: "Arquivado" };
const ORIGEM = { venda: "Venda de carta", parceiro: "Parceiro" };

const fmtDate = (iso) => new Date(iso).toLocaleString("pt-BR", { dateStyle: "short", timeStyle: "short" });

const LeadRow = ({ l, onStatus }) => (
  <div className="grid gap-3 rounded-[20px] border border-[#C8D7E4] bg-white p-5 md:grid-cols-[1.4fr_1fr_1.4fr_auto] md:items-center" data-testid={`admin-lead-row-${l.id}`}>
    <div>
      <p className="font-bold text-[#15579A]">{l.nome}</p>
      <a href={`https://wa.me/55${l.whatsapp.replace(/\D/g, "").replace(/^55/, "")}`} target="_blank" rel="noopener noreferrer"
        className="text-sm text-[#196ABC] hover:underline">{l.whatsapp}</a>
    </div>
    <div className="text-sm">
      <span className="rounded-full bg-[#218FFF]/10 px-3 py-1 font-semibold text-[#196ABC]">{ORIGEM[l.origem]}</span>
      <p className="mt-2 text-xs text-[#15579A]/60">{fmtDate(l.created_at)}</p>
    </div>
    <div className="text-sm text-[#15579A]/80">
      {l.administradora && <p>Adm.: {l.administradora}</p>}
      {l.valor_credito && <p>Crédito: {l.valor_credito}</p>}
      {l.cidade && <p>{l.cidade}</p>}
      {l.mensagem && <p className="italic">“{l.mensagem}”</p>}
    </div>
    <Select value={l.status} onValueChange={(v) => onStatus(l.id, v)}>
      <SelectTrigger className="w-40 rounded-full" data-testid={`admin-lead-status-select-${l.id}`}><SelectValue /></SelectTrigger>
      <SelectContent>
        {Object.entries(STATUS).map(([k, v]) => <SelectItem key={k} value={k} data-testid={`admin-lead-status-option-${k}`}>{v}</SelectItem>)}
      </SelectContent>
    </Select>
  </div>
);

export const LeadsTab = ({ api }) => {
  const [leads, setLeads] = useState(null);
  const [filtro, setFiltro] = useState("todos");

  useEffect(() => {
    api("get", "/admin/leads").then(setLeads).catch(() => toast.error("Erro ao carregar leads"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onStatus = async (id, status) => {
    await api("patch", `/admin/leads/${id}`, { status });
    setLeads((ls) => ls.map((l) => (l.id === id ? { ...l, status } : l)));
    toast.success("Status atualizado");
  };

  if (!leads) return <p className="text-[#15579A]/70">Carregando...</p>;
  const shown = filtro === "todos" ? leads : leads.filter((l) => l.origem === filtro);
  return (
    <div>
      <div className="mb-5 flex flex-wrap items-center gap-2">
        {["todos", "venda", "parceiro"].map((f) => (
          <button key={f} onClick={() => setFiltro(f)} data-testid={`admin-leads-filter-${f}`}
            className={`rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${filtro === f ? "bg-[#196ABC] text-[#F7F5F0]" : "bg-[#C8D7E4]/50 text-[#15579A]"}`}>
            {f === "todos" ? "Todos" : ORIGEM[f]}
          </button>
        ))}
        <span className="ml-auto text-sm text-[#15579A]/70" data-testid="admin-leads-count">{shown.length} lead(s)</span>
      </div>
      <div className="space-y-3">
        {shown.length === 0 && <p className="text-sm text-[#15579A]/70" data-testid="admin-leads-empty">Nenhum lead ainda.</p>}
        {shown.map((l) => <LeadRow key={l.id} l={l} onStatus={onStatus} />)}
      </div>
    </div>
  );
};
